import React, { useState, useEffect } from 'react';
import { LanguagesApi, UserGroupsApi } from '../../api';
import { CommonDataContext } from './CommonDataContext';
import { hasPermission } from 'utility/accessibility/hasPermission';

const languagesApi = new LanguagesApi();
const userGroupsApi = new UserGroupsApi();

export const CommonDataProvider = ({ children }) => {
  const user = localStorage.getItem('user');
  const [commonData, setCommonData] = useState({
    userGroups: [],
    languages: [],
    isLoading: false,
  });

  const fetchCommonData = async () => {
    setCommonData(prev => ({ ...prev, isLoading: true }));
    try {
      const [languagesResponse, userGroupsResponse] = await Promise.all([
        languagesApi.apiLanguagesForUiGet(),
        hasPermission('user-groups:list') ? userGroupsApi.apiUserGroupsGet() : { data: [] },
      ]);

      setCommonData(prev => ({
        ...prev,
        languages: languagesResponse?.data,
        userGroups: userGroupsResponse?.data,
        isLoading: false,
      }));
    } catch (error) {
      console.error(error);
      setCommonData(prev => ({ ...prev, isLoading: false }));
    }
  };

  useEffect(() => {
    fetchCommonData();
  }, []);

  const contextValue = {
    ...commonData,
    refreshCommonData: fetchCommonData,
  };

  // If not authenticated, just render children without fetching data
  if (!user) {
    return <>{children}</>;
  }

  return <CommonDataContext.Provider value={contextValue}>{children}</CommonDataContext.Provider>;
};
